import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SuperAdmin from "@/features/superadmin";
import Admin from "@/features/admin";
import Dealer from "@/features/dealer";
import Agent from "@/features/agent";
import Customer from "@/features/customer";
import SitePreview from "@/pages/SitePreview";
import TenantLogin from "@/pages/TenantLogin";
import SiteWrapper from "@/components/SiteWrapper";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { getStoredUser, roleHome, getActiveSubdomain } from "@/lib/api";
import { useParams } from "react-router-dom";

function Protected({ roles, children }) {
  const user = getStoredUser();
  const { subdomain: paramSubdomain } = useParams();
  const subdomain = getActiveSubdomain() || paramSubdomain;
  
  if (!user) {
    if (subdomain) {
      if (getActiveSubdomain()) return <Navigate to="/login" replace />;
      return <Navigate to={`/site/${subdomain}/login`} replace />;
    }
    return <Navigate to="/login" replace />;
  }
  
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={roleHome(user.role, subdomain)} replace />;
  }
  return children;
}

export default function App() {
  const activeSubdomain = getActiveSubdomain();

  if (activeSubdomain) {
    return (
      <div className="App">
        <Toaster richColors position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route element={<SiteWrapper />}>
              <Route index element={<SitePreview />} />
              <Route path="login" element={<TenantLogin />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="admin/*" element={<Protected roles={["admin"]}><Admin /></Protected>} />
              <Route path="dealer/*" element={<Protected roles={["dealer","staff"]}><Dealer /></Protected>} />
              <Route path="agent/*" element={<Protected roles={["agent"]}><Agent /></Protected>} />
              <Route path="customer/*" element={<Protected roles={["customer"]}><Customer /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/site/:subdomain" element={<SiteWrapper />}>
            <Route index element={<SitePreview />} />
            <Route path="login" element={<TenantLogin />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="admin/*" element={<Protected roles={["admin"]}><Admin /></Protected>} />
            <Route path="dealer/*" element={<Protected roles={["dealer","staff"]}><Dealer /></Protected>} />
            <Route path="agent/*" element={<Protected roles={["agent"]}><Agent /></Protected>} />
            <Route path="customer/*" element={<Protected roles={["customer"]}><Customer /></Protected>} />
          </Route>
          <Route path="/superadmin/*" element={<Protected roles={["superadmin"]}><SuperAdmin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
